module.exports = __webpack_public_path__ + "static/snippets-e911470bfce63515882f9d71247d6b6e.png";